/* raw layout hash: _default-web-layout-7gr5z5:b7f81eee5c3f18adc79dfaf542d62f675e94651ba213a221fccbe7c32b6ca5d1 */
import React from "react";
import AppShell from "./AppShell.jsx";

// Layout "_default-web-layout-7gr5z5" (RawHTMLDesign/layouts/_default-web-layout-7gr5z5.html)
export default function DefaultWebLayout7gr5z5({ children }) {
  return <AppShell menuKey="set6">{children}</AppShell>;
}
